export let overflowWellKeytip = "iMvFLc";
export let bottomBarOverflowMenuLabel = "$H_zbe";
export let commandRibbonLabel = "xQuKXc";
export let tabsContainerLabel = "nMify";
export let tabsContainerOverflowLabel = "fFuONb";
export let peripheralControlsGroupLabel = "hasiee";
export let calloutCloseLabel = "Ip7WLe";
export let taskPaneOverflowMenuLabel = "azVEhc";
export let ribbonModeChevronLabel = "S5savb";
export let ribbonModeChevronKeytip = "g03h8d";
export let taskPaneTabsContainerLabel = "a98dBd";
export let taskPaneRoleDescription = "berb6c";
export let taskPaneOpeningString = "WcYoBb";
export let rightRibbonPaddleLabel = "ADVMKb";
export let leftRibbonPaddleLabel = "Dye2lb";
export let search = "gZJP4c";
export let ribbonSearchLabel = "abxZB";
export let searchableMenuRegionLabel = "T7DXC";
export let clearSearch = "ttWKQd";
export default {overflowWellKeytip,bottomBarOverflowMenuLabel,commandRibbonLabel,tabsContainerLabel,tabsContainerOverflowLabel,peripheralControlsGroupLabel,calloutCloseLabel,taskPaneOverflowMenuLabel,ribbonModeChevronLabel,ribbonModeChevronKeytip,taskPaneTabsContainerLabel,taskPaneRoleDescription,taskPaneOpeningString,rightRibbonPaddleLabel,leftRibbonPaddleLabel,search,ribbonSearchLabel,searchableMenuRegionLabel,clearSearch};